/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../../../graphql/types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddonsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AddonsQuery = {
  readonly __typename?: 'Query';
  readonly addons: {
    readonly __typename?: 'Addons';
    readonly products: ReadonlyArray<{
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly cost: number;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
  };
};

export const AddonsDocument = gql`
  query addons {
    addons {
      products {
        id
        name
        cost
        asset {
          url
        }
      }
    }
  }
`;

export function useAddonsQuery(
  options?: Omit<Urql.UseQueryArgs<AddonsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AddonsQuery, AddonsQueryVariables>({
    query: AddonsDocument,
    ...options,
  });
}
